export default __webpack_public_path__ + "img/ecb235509d38036971742d5b52c2f783.png";